// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bahamas from '../_raw/flag/icon_flag_bahamas.png';

export default () => <img src={Bahamas} alt="Bahamas" />;
